var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", [
    _c(
      "div",
      {
        staticClass: "tree-node-div",
        class: [
          _vm.currentHover == _vm.index ? "tr-hover" : "",
          _vm.$store.state.clickItem == _vm.model ||
          (_vm.$store.state.syncClickItem == _vm.model && _vm.transferAimFlag)
            ? "tr-click"
            : "tr-0d0s7",
          _vm.$store.state.arr.includes(_vm.model) ||
          _vm.$store.state.syncArr.includes(_vm.model)
            ? "tr-click"
            : "tr-0d0s9"
        ],
        on: {
          mouseover: function($event) {
            return _vm.changeHover(_vm.index)
          },
          mouseout: function($event) {
            _vm.currentHover = -1
          },
          click: function($event) {
            return _vm.chooseItem(_vm.model)
          }
        }
      },
      [
        _c(
          "span",
          {
            staticClass: "tr-height tr-tree-span",
            on: {
              click: function($event) {
                $event.stopPropagation()
                return _vm.toggle(_vm.index, _vm.model)
              }
            }
          },
          [
            _vm.testShow(_vm.model)
              ? _c("i", {
                  staticClass: "icon-util  pull-triangle-position",
                  class: [_vm.model.open ? "down-triangle" : "pull-triangle"]
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.testShow(_vm.model)
              ? _c("i", {
                  staticClass: "icon-util  pull-triangle-position",
                  staticStyle: { width: "20Px", height: "20Px" }
                })
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "tr-tree-span" }, [
          _c("div", {
            staticClass: "icon-util folder-position",
            class: _vm.$store.state.arr.includes(_vm.model)
              ? "check-small"
              : "nocheck-small",
            staticStyle: { top: "11px" }
          }),
          _vm._v(" "),
          _c("i", {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading"
              }
            ],
            staticClass: "folder-position ",
            class: [
              _vm.model.appName
                ? _vm.returnName(_vm.model.appName)
                : "small-file",
              _vm.model.dir ? "folder-small" : "",
              !_vm.model.dir && !_vm.model.appName
                ? _vm.matchfileType(_vm.model.name) + "-small"
                : ""
            ]
          }),
          _vm._v(" "),
          _c(
            "span",
            {
              ref: "treeItemName",
              staticClass: "tr-tree-name-span",
              attrs: { title: _vm.model.name },
              on: {
                dblclick: function($event) {
                  $event.stopPropagation()
                  return _vm.toggle(_vm.index, _vm.model)
                }
              }
            },
            [_vm._v(_vm._s(_vm.model.name))]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "editTreeName",
              staticClass: "tree-innerclass",
              class: _vm.isflage ? "tree-innerclass" : "tree-innerclass-not"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inputValue,
                    expression: "inputValue"
                  }
                ],
                class: _vm.isflage ? "tree-name-edit" : "tree-name-not",
                domProps: { value: _vm.inputValue },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                  },
                  focus: function($event) {
                    _vm.isflage = true
                  },
                  blur: function($event) {
                    $event.stopPropagation()
                    return _vm.submitFolder(_vm.model)
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.inputValue = $event.target.value
                  }
                }
              }),
              _vm._v(" "),
              _c("span", { staticClass: "tree-input-icon" }, [
                _c("i", {
                  staticClass: "icon-util name-sure",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.submitFolder(_vm.model)
                    }
                  }
                }),
                _vm._v(" "),
                _c("i", {
                  staticClass: "icon-util name-cancel ",
                  on: {
                    mousedown: function($event) {
                      $event.stopPropagation()
                      return _vm.cancelNewFolder(_vm.model)
                    }
                  }
                })
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("i", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                (_vm.treeShow && _vm.model.driveType != "googlePhotos") ||
                (_vm.treeShow &&
                  (_vm.model.driveType == "googlePhotos" &&
                    _vm.model.id == "/albums")),
              expression:
                "(treeShow&&model.driveType!='googlePhotos')||(treeShow&&(model.driveType=='googlePhotos'&&model.id == '/albums'))"
            }
          ],
          staticClass: "icon-util add-folder-positon",
          class: [_vm.currentHover == _vm.index ? "add-folder" : ""],
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.addNewFolder(_vm.index, _vm.model)
            }
          }
        })
      ]
    ),
    _vm._v(" "),
    _c(
      "ul",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.model.open,
            expression: "model.open"
          }
        ]
      },
      _vm._l(_vm.model.children, function(item, index) {
        return _c("tree-menu", {
          key: index,
          attrs: {
            treeShow: _vm.treeShow,
            model: item,
            index: index,
            transferAimFlag: _vm.transferAimFlag
          }
        })
      }),
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7e109e8d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e109e8d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/trees/sub_account_tree.vue
// module id = null
// module chunks = 